import { BookingSteps } from "../../../../_common/steps/booking-steps"
import { ECommerceState } from "./e-commerce-machine"
import {
    ECommerceFareSelectedContext,
    ECommerceReadyToCheckoutContext,
    ECommerceSuiteCategorySelectedContext,
    ECommerceSuiteNumberSelectedContext,
} from "./e-commerce-machine-context"

export const canGoToGuestsV4 = (state: ECommerceState): boolean => canChangeAnything(state)

export const canGoToFare = (state: ECommerceState): boolean => canChangeAnything(state)
export const canGoToFareV4 = (state: ECommerceState) =>
    state.matches("flow.suiteCategorySelectedV4") ||
    state.matches("flow.fareSelectedV4") ||
    state.matches("flow.suiteNumberSelectedV4")

export const canGoToCategories = (state: ECommerceState): boolean => canSelectSuiteCategory(state)
export const canGoToCategoriesV4 = (state: ECommerceState): boolean => canSelectSuiteCategoryV4(state)
export const canSelectSuiteCategory = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceFareSelectedContext } =>
    state.matches("flow.fareSelected") ||
    state.matches("flow.suiteCategorySelected") ||
    state.matches("flow.suiteNumberSelected")
export const canSelectSuiteCategoryV4 = <T extends ECommerceState>(state: T) =>
    // TODO - v4: here we need to decide if the user should wait on the guest selection step or move forward and wait on the suite category step
    state.matches("flow.nothingSelectedV4") ||
    state.matches("flow.suiteCategorySelectedV4") ||
    state.matches("flow.fareSelectedV4") ||
    state.matches("flow.suiteNumberSelectedV4")

export const canGoToSuite = (state: ECommerceState): boolean => canSelectSuiteNumber(state)
export const canSelectSuiteNumber = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteCategorySelectedContext } =>
    state.matches("flow.suiteCategorySelected.suiteNumberUnselectable") ||
    state.matches("flow.suiteCategorySelected.suiteNumberSelectable") ||
    state.matches("flow.suiteNumberSelected")

export const canGoToSendQuote = (state: ECommerceState): boolean =>
    state.matches("flow.suiteCategorySelected") || state.matches("flow.suiteNumberSelected")
export const canGoToSendQuoteV4 = (state: ECommerceState): boolean =>
    state.matches("flow.fareSelectedV4") || state.matches("flow.suiteNumberSelectedV4")

export const canGoToGuestsInfo = (state: ECommerceState): boolean => canFillGuestsInfo(state)
export const canGoToGuestsInfoV4 = (state: ECommerceState): boolean => canFillGuestsInfoV4(state)
export const canFillGuestsInfo = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedContext } =>
    //keep-line
    state.matches("flow.suiteNumberSelected")
export const canFillGuestsInfoV4 = <T extends ECommerceState>(state: T) =>
    //keep-line
    state.matches("flow.suiteNumberSelectedV4")

export const isCheckout = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedContext } => state.matches("flow.checkout")

export const isWebQuote = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedContext } => state.matches("flow.webQuote")

export const isCourtesyHold = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedContext } => state.matches("flow.courtesyHold")

export const isReadyToCheckout = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceReadyToCheckoutContext } =>
    state.matches("flow.checkout.validated") ||
    state.matches("flow.readyToCheckout.starting") ||
    state.matches("flow.readyToCheckout.paying") ||
    state.matches("flow.readyToCheckout.error") ||
    state.matches("flow.readyToCheckout.completed")

export const isPayment = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceReadyToCheckoutContext } => state.matches("flow.readyToCheckout")

const canChangeAnything = (state: ECommerceState) =>
    !isWebQuote(state) && !isCourtesyHold(state) && !isCheckout(state) && !isPayment(state)

export const canGoToPayments = (state: ECommerceState): boolean => state.matches("flow.checkout.validated")

export const canGoToNextStep = (currentStep: BookingSteps, state: ECommerceState): boolean =>
    state.context.flowVersion.steps.canGoToNextStep(currentStep, state)

export const goToNextStepPath = (currentStep: BookingSteps, state: ECommerceState) =>
    state.context.flowVersion.steps.goToNextStepPath(currentStep)
